import React from "react";
import {
  Box,
  RadioGroupProps as ChakraRadioGroupProps,
  RadioProps as ChakraRadioProps,
  HStack,
  StackProps,
  forwardRef,
  useRadio,
  useRadioGroup,
  useStyleConfig,
} from "@chakra-ui/react";

import { RadioOutlineIcon, RadioSelectedIcon } from "../icons";

export const Radio = forwardRef<ChakraRadioProps, "input">((props, ref) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const { onMouseLeave, onMouseEnter, ...checkbox } = getCheckboxProps();

  const styles = useStyleConfig("BlueprintRadio");

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isChecked = input.checked;

  return (
    <Box as="label" ref={ref}>
      <input {...input} />
      <Box
        as="span"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          as={isChecked ? RadioSelectedIcon : RadioOutlineIcon}
          {...checkbox}
          __css={styles}
        />
        {props.children}
      </Box>
    </Box>
  );
});

interface RadioGroupProps extends ChakraRadioGroupProps {
  stackProps?: StackProps;
}

export const RadioGroup = forwardRef<RadioGroupProps, "div">(
  ({ stackProps, ...rest }) => {
    const { getRootProps, getRadioProps } = useRadioGroup(rest);

    const childrenWithProps = React.Children.map(rest.children, (child) => {
      // Checking isValidElement is the safe way and avoids a typescript
      // error too.
      if (React.isValidElement(child)) {
        return React.cloneElement(
          child,
          getRadioProps({ value: child.props.value })
        );
      }
      return child;
    });

    const group = getRootProps();

    return (
      <HStack {...group} {...stackProps}>
        {childrenWithProps}
      </HStack>
    );
  }
);
